<template>
  <div>
    <!-- <h1>Tabela de ocorrências de/para</h1>
    <br />-->
    <!-- <h1>Ocorrências entrega</h1> -->

    <div v-if="tableItems.length > 0">
      <b-row>
        <b-table
          ref="selectableTable"
          id="table-tabela-proceda"
          hover
          :items="tableItems"
          :fields="tableFields"
          :per-page="perPage"
          :current-page="currentPage"
        >
          <template v-slot:cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true">&check;</span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true">&nbsp;</span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>
          <!-- <template v-slot:cell(id)="data">
        <router-link :to="'/usuario/edit/' + data.value">{{ data.value }}</router-link>
          </template>-->
        </b-table>
      </b-row>

      <b-row>
        <b-col sm="5" md="5" lg="5" class="mt-1">
          <b-pagination
            v-model="tableCurrentPage"
            :total-rows="tableRowCount"
            :per-page="tablePerPage"
            first-number
            last-number
            aria-controls="table-tabela-proceda"
          ></b-pagination>
        </b-col>
        <b-col sm="4" md="4" lg="4" class="mt-2">
          <label
            for="perPageSelect"
          >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de {{tableRowCount}}</label>
        </b-col>
        <b-col sm="3" md="3" lg="3">
          <b-form-group
            label-cols-md="6"
            label="Por página"
            label-align-md="right"
            label-for="perPageSelect"
          >
            <b-form-select
              class="mt-1"
              v-model="tablePerPage"
              id="perPageSelect"
              size="sm"
              :options="tablePageOptions"
            ></b-form-select>
          </b-form-group>
          <!-- <b-form-select
            v-model="tablePerPage"
            id="perPageSelect"
            size="sm"
            :options="tablePageOptions"
          ></b-form-select>-->
        </b-col>
      </b-row>
    </div>
    <div v-if="tableItems.length == 0">
      <b-alert show variant="info">Essa entrega ainda não possui ocorrências registradas</b-alert>
    </div>
 
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
//import ListEntregaOcorrencia from "./components/entregaOcorrencia/List";
// ListEntregaOcorrencia

export default {
  name: "ListEntregaOcorrencia",
  props: {
    id: String,
  },
  data: function () {
    return {
      tableFields: [
        {
          label: "Embarcador",
          key: "shipperName",
          sortable: true,
        },
        {
          label: "Transportador",
          key: "shippingCompanyName",
          sortable: true,
        },
        {
          label: "Data de ocorrencia",
          key: "occurrenceDate",
          sortable: true,
        },
        {
          label: "Código PROCEDA",
          key: "occurrenceCode",
          sortable: true,
        },
        {
          label: "Descrição PROCEDA",
          key: "occurrenceDescription",
          sortable: true,
        },
        {
          label: "Código EDI",
          key: "ediCode",
          sortable: true,
        },
      ],
      tableItems: [],
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
    };
  },
  computed: {
    tableRowCount() {
      return this.tableItems.length;
    },
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  created: function () {
    this.loadData();
  },
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    async loadData() {     

      // this.tableItems = [
      //   {
      //     codigoOcorrencia: "",
      //     dataOcorrencia: "24/08/2020",
      //     ocorrenciaProceda: {
      //       codigo: "",
      //       descricao: "Nota fiscal emitida",
      //     },
      //     embarcador: {
      //       razaoSocial: "CATERPILLAR BRASIL COMERCIO DE MAQUINAS E PECAS LTDA",
      //     },
      //     transportador: {
      //       razaoSocial: "SOTREQ S/A SOTREQ CARAJAS",
      //     },
      //   },
      //   {
      //     codigoOcorrencia: "",
      //     dataOcorrencia: "25/08/2020",
      //     ocorrenciaProceda: {
      //       codigo: "",
      //       descricao: "Mercadoria coleta",
      //     },
      //     embarcador: {
      //       razaoSocial: "CATERPILLAR BRASIL COMERCIO DE MAQUINAS E PECAS LTDA",
      //     },
      //     transportador: {
      //       razaoSocial: "SOTREQ S/A SOTREQ CARAJAS",
      //     },
      //   },
      //   {
      //     codigoOcorrencia: "00",
      //     dataOcorrencia: "25/08/2020",
      //     ocorrenciaProceda: {
      //       codigo: "00",
      //       descricao: "Processo de Transporte já Iniciado",
      //     },
      //     embarcador: {
      //       razaoSocial: "CATERPILLAR BRASIL COMERCIO DE MAQUINAS E PECAS LTDA",
      //     },
      //     transportador: {
      //       razaoSocial: "SOTREQ S/A SOTREQ CARAJAS",
      //     },
      //   },
      //   {
      //     codigoOcorrencia: "01",
      //     dataOcorrencia: "26/08/2020",
      //     ocorrenciaProceda: {
      //       codigo: "01",
      //       descricao: "Entrega Realizada Normalmente",
      //     },
      //     embarcador: {
      //       razaoSocial: "CATERPILLAR BRASIL COMERCIO DE MAQUINAS E PECAS LTDA",
      //     },
      //     transportador: {
      //       razaoSocial: "SOTREQ S/A SOTREQ CARAJAS",
      //     },
      //   },
      // ];

      this.$api
        .get("/deliveryoccurrency/get/" + this.id)
        .then((response) => {
          this.tableItems = response.data;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response);
          if (err.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
  },
};
</script>

<style>

/* table tr {
  white-space: nowrap;
} */
</style>